// extracted by mini-css-extract-plugin
module.exports = {"common_title":"commonTitle_common_title__U0tCe"};